import React, { useState, useEffect, useRef, useCallback} from 'react';
import { FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { db } from '../FirebaseComp/firebase'; // Adjust path to your firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { Link } from 'react-router-dom';

import emailjs from 'emailjs-com'; // import at top
import { ChevronLeft, ChevronRight, Award, Users } from 'lucide-react';



import './body.css';
import {
  Car,
  UserCheck,
  BadgeDollarSign,
  Headphones,
  Smartphone,
  Clock,
  Sparkles,
  Handshake
} from 'lucide-react';

import { FaCheckCircle } from 'react-icons/fa';


function Body() {

// const [currentIndex, setCurrentIndex] = useState(1); // Start at first real slide
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const intervalRef = useRef(null);

// const slides = [
//   {
//     image: "/banner1.webp",
//     title: "Advanced Prosthetic Solutions",
//     subtitle: "Restoring mobility, transforming lives"
//   },
//   {
//     image: "/banner2.png",
//     title: "Custom Orthotic Care",
//     subtitle: "Precision-engineered for your comfort"
//   },
//   {
//     image: "/banner3.png",
//     title: "Orthopedic Rehabilitation",
//     subtitle: "Expert guidance through every step"
//   },
//   {
//     image: "/banner4.jpg",
//     title: "Compassionate Professional Care",
//     subtitle: "Where technology meets humanity"
//   }
// ];











// const handleNext = () => {
//   setCurrentIndex((prev) => (prev + 1) % slides.length);
// };

// const handlePrev = () => {
//   setCurrentIndex((prev) =>
//     prev === 0 ? slides.length - 1 : prev - 1
//   );
// };

// const goToSlide = (index) => {
//   setCurrentIndex(index);
// };

// useEffect(() => {
//   intervalRef.current = setInterval(handleNext, 5000);
//   return () => clearInterval(intervalRef.current);
// }, []);

// const pauseAutoPlay = () => clearInterval(intervalRef.current);

// const resumeAutoPlay = () => {
//   intervalRef.current = setInterval(handleNext, 5000);
// };
  

const [currentIndex, setCurrentIndex] = useState(0);
const intervalRef = useRef(null);

const slides = [
  {
    image: "/banner1.webp",
    title: "Advanced Prosthetic Solutions",
    subtitle: "Restoring mobility, transforming lives"
  },
  {
    image: "/banner2.webp",
    title: "Custom Orthotic Care",
    subtitle: "Precision-engineered for your comfort"
  },
  {
    image: "/banner3.webp",
    title: "Orthopedic Rehabilitation",
    subtitle: "Expert guidance through every step"
  },
  {
    image: "/banner4.webp",
    title: "Compassionate Professional Care",
    subtitle: "Where technology meets humanity"
  }
];

// ============================
// FUNCTIONS
// ============================
const handleNext = () => {
  setCurrentIndex((prev) => (prev + 1) % slides.length);
};

const handlePrev = () => {
  setCurrentIndex((prev) =>
    prev === 0 ? slides.length - 1 : prev - 1
  );
};

const goToSlide = (index) => {
  setCurrentIndex(index);
};

// ============================
// AUTOPLAY FIXED
// ============================
const startAutoPlay = () => {
  clearInterval(intervalRef.current);

  intervalRef.current = setInterval(() => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  }, 5000);
};

const pauseAutoPlay = () => {
  clearInterval(intervalRef.current);
};

const resumeAutoPlay = () => {
  startAutoPlay();
};

// ============================
// USE EFFECT
// ============================
useEffect(() => {
  // preload images
  slides.forEach((slide) => {
    const img = new Image();
    img.src = slide.image;
  });

  startAutoPlay();

  return () => clearInterval(intervalRef.current);
}, []);








   const [experience, setExperience] = useState(0);

  useEffect(() => {
    let start = 0;
    const target = 15;
    const increment = target / 100;
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setExperience(target);
      } else {
        setExperience(parseFloat(start.toFixed(1)));
      }
    }, 30);
  }, []);














    const [expandedImage, setExpandedImage] = useState(null);
  
    const images = [
      { src: "/img1.png", alt: "" },
      { src: "/img2.png", alt: "" },
      { src: "/img3.png", alt: "" },
      { src: "/img4.webp", alt: "" },
      { src: "/img5.png", alt: "" },
      { src: "/img6.jpg", alt: "" },
      { src: "/img7.jpg", alt: "" },
      { src: "/img8.jpg", alt: "" },
      { src: "/img9.jpg", alt: "" },
 
    ];
  
    // Always show 3 images (current, next, and previous)
    const visibleImages = [];
    for (let i = -1; i <= 1; i++) {
      const index = (currentIndex + i + images.length) % images.length;
      visibleImages.push(images[index]);
    }
  
    const moveNext = () => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    };
  
    const movePrev = () => {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };
  
    const handleImageClick = (image) => {
      setExpandedImage(image);
      clearInterval(intervalRef.current);
    };
  
    const closeExpandedImage = () => {
      setExpandedImage(null);
      intervalRef.current = setInterval(moveNext, 2000);
    };
  
    useEffect(() => {
      intervalRef.current = setInterval(moveNext, 2000);
      return () => clearInterval(intervalRef.current);
    }, []);
  
    const handleMouseEnter = () => clearInterval(intervalRef.current);
    const handleMouseLeave = () => {
      if (!expandedImage) {
        intervalRef.current = setInterval(moveNext, 2000);
      }
    };
  






const leftBenefits = [
  {
    title: 'Custom Prosthetic Solutions',
    description:
      'High-quality artificial limbs designed for comfort, durability, and improved mobility.',
  },
  {
    title: 'Personalized Rehabilitation',
    description:
      'Tailored rehabilitation programs to help patients regain strength and independence.',
  },
];

const rightBenefits = [
  {
    title: 'Advanced Orthotic Support',
    description:
      'Specially designed braces and orthotic devices for optimal body alignment and correction.',
  },
  {
    title: 'Child Orthopedic Care',
    description:
      'Gentle and professional orthopedic solutions specially designed for children.',
  },
];




const renderBenefit = ({ title, description }, index) => (
  <div className="benefit-item" key={index}>
    <div className="benefit-icon">
      <FaCheckCircle />
    </div>
    <div className="benefit-content">
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </div>
);











  return (
    <main className="body-container">



      {/* <section
  className="hero"
  onMouseEnter={pauseAutoPlay}
  onMouseLeave={resumeAutoPlay}
>
  <div
    className="hero-slider"
    style={{
      transform: `translateX(-${currentIndex * 100}%)`
    }}
  >
    {slides.map((slide, index) => (
      <div
        key={index}
        className="hero-slide"
        style={{ backgroundImage: `url(${slide.image})` }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-text">
            <span className="hero-badge">
              Southern Rehab Care
            </span>

            <h1 className="hero-title">{slide.title}</h1>

            <p className="hero-subtitle">
              {slide.subtitle}
            </p>

            <div className="hero-buttons">
              <Link to="/contactus" className="btn btn-primary">
                Schedule Consultation
              </Link>

              <Link to="/aboutus" className="btn btn-secondary">
                Our Story
              </Link>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>


  <div className="hero-dots">
    {slides.map((_, idx) => (
      <button
        key={idx}
        className={`hero-dot ${currentIndex === idx ? "active" : ""}`}
        onClick={() => goToSlide(idx)}
      />
    ))}
  </div>


  <button className="hero-arrow hero-arrow-prev" onClick={handlePrev}>
    ❮
  </button>

  <button className="hero-arrow hero-arrow-next" onClick={handleNext}>
    ❯
  </button>
</section> */}



<section
  className="hero"
  onMouseEnter={pauseAutoPlay}
  onMouseLeave={resumeAutoPlay}
>
  <div
    className="hero-slider"
    style={{
      transform: `translateX(-${currentIndex * 100}%)`
    }}
  >
    {slides.map((slide, index) => (
      <div
        key={index}
        className="hero-slide"
        style={{
          backgroundImage: `url(${slide.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#0b1f2a"
        }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-text">
            <span className="hero-badge">
              Southern Rehab Care
            </span>

            <h1 className="hero-title">
              {slide.title}
            </h1>

            <p className="hero-subtitle">
              {slide.subtitle}
            </p>

            <div className="hero-buttons">
              <Link
                to="/contactus"
                className="btn btn-primary"
              >
                Schedule Consultation
              </Link>

              <Link
                to="/aboutus"
                className="btn btn-secondary"
              >
                Our Story
              </Link>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* DOTS */}
  <div className="hero-dots">
    {slides.map((_, idx) => (
      <button
        key={idx}
        className={`hero-dot ${
          currentIndex === idx ? "active" : ""
        }`}
        onClick={() => goToSlide(idx)}
      />
    ))}
  </div>

  {/* ARROWS */}
  <button
    className="hero-arrow hero-arrow-prev"
    onClick={handlePrev}
  >
    ❮
  </button>

  <button
    className="hero-arrow hero-arrow-next"
    onClick={handleNext}
  >
    ❯
  </button>
</section>














      {/* Services Section */}

<div className="services-section">
  <h1 className="services-heading">
    Comprehensive Orthopedic Rehabilitation & Prosthetic Care
  </h1>

  <div className="services-content">

    <div className="image-section">
      <img
        src="/rehab-logo.png"
        alt="Orthopedic Rehabilitation"
        className="main-image"
      />

      <div className="experience-box">
        <span className="experience-number">{experience}+</span>
        <span className="experience-label">
          Years of Professional Experience
        </span>
      </div>
    </div>

    <div className="info-section">

      <p className="services-description">
        We provide advanced prosthetic limb solutions, custom orthotic devices,
        and comprehensive orthopedic rehabilitation support for adults and children.
        Our goal is to improve mobility, comfort, and independence through
        personalized and compassionate care.
      </p>

      <div className="info-item">
        <div className="info-icon"></div>
        <div>
          <h3 className="info-title">
            Custom Prosthetic & Orthotic Solutions
          </h3>
          <p className="info-text">
            High-quality artificial limbs and specially designed braces
            tailored to individual patient needs for maximum comfort and performance.
          </p>
        </div>
      </div>

      <div className="info-item">
        <div className="info-icon"></div>
        <div>
          <h3 className="info-title">
            Rehabilitation & Mobility Support
          </h3>
          <p className="info-text">
            Professional rehabilitation guidance to help patients regain strength,
            balance, and confidence in daily activities.
          </p>
        </div>
      </div>

    </div>
  </div>
</div>


     




<section className="world-brand-section">
  <div className="world-brand-container">

    <div className="world-brand-text">
      <h2>Trusted Partnership with Global Leader Ottobock</h2>

      <p>
We are the official partner for the Southern Province of Ottobock, a world-leading manufacturer of 
advanced prosthetic and orthotic solutions, ensuring our patients receive internationally recognized quality 
and innovation.

      </p>

    </div>

    <div className="ottobock-image">
      <img src="/ottobock.png" alt="Rehabilitation Care" />
    </div>

  </div>
</section>







  <section className="why-choose-section">
  <div className="why-choose-container">

    <div className="why-choose-text">
      <h2>Why Choose Southern Rehab Care?</h2>

      <p>
        We are dedicated to delivering advanced orthopedic rehabilitation,
        prosthetic, and orthotic services with precision, care, and professionalism.
        Our experienced team ensures personalized solutions that improve mobility
        and enhance quality of life.
      </p>

      <div className="highlight-section">

        <div className="highlight-box">
          <h3>Our Services</h3>
          <ul>
            <li>Upper Extremity Prosthetics & Orthotics</li>
            <li>Lower Extremity Prosthetics & Orthotics</li>
            <li>Rehabilitation Mobility Solutions</li>
            <li>Orthopedic Care for Children</li>
          </ul>
        </div>

        <div className="highlight-box">
          <h3>What You Receive</h3>
          <ul>
            <li>Personalized Treatment Plans</li>
            <li>High-Quality Custom Devices</li>
            <li>Professional Clinical Support</li>
            <li>Compassionate Patient Care</li>
          </ul>
        </div>

      </div>
    </div>

    <div className="why-choose-image">
      <img src="/years of experience.jpg" alt="Rehabilitation Care" />
    </div>

  </div>
</section>






 <section className="home-scoliosis-section">
      <div className="home-scoliosis-container">
        
        {/* Left Content */}
        <div className="home-scoliosis-content">
          <span className="home-scoliosis-badge">Specialized Care</span>
          <h2 className="home-scoliosis-heading">
            Scoliosis & <span className="home-scoliosis-highlight">Spinal Health Program</span>
          </h2>
          
          <p className="home-scoliosis-description">
            Managing scoliosis requires a specialized approach that goes beyond general exercise. 
            At our center, we provide comprehensive care for both children and adults with spinal curvatures.
          </p>
          
          <div className="home-scoliosis-features">
            <div className="home-scoliosis-feature">
              <span className="home-scoliosis-feature-icon">✓</span>
              <span><strong>Customized Corrective Exercises:</strong> We design specific programs aimed at improving posture, strengthening core stabilizers, and reducing the progression of the curve.</span>
            </div>
            <div className="home-scoliosis-feature">
              <span className="home-scoliosis-feature-icon">✓</span>
              <span><strong>Postural Re-education:</strong> Training the body to find a more neutral alignment through conscious movement and breathing techniques.</span>
            </div>
            <div className="home-scoliosis-feature">
              <span className="home-scoliosis-feature-icon">✓</span>
              <span><strong>Integrated Bracing Support:</strong> For patients using spinal orthoses, our physiotherapists work in tandem with our orthotics team to ensure the brace is comfortable and that the patient maintains muscle tone while wearing it.</span>
            </div>
            <div className="home-scoliosis-feature">
              <span className="home-scoliosis-feature-icon">✓</span>
              <span><strong>Pain Management:</strong> Targeting the muscle imbalances often associated with scoliosis to reduce discomfort and improve daily function.</span>
            </div>
          </div>

          {/* Why Specialized Scoliosis PT Matters */}
          <div className="home-scoliosis-why-matters">
            <h3 className="home-scoliosis-why-heading">Why Specialized Scoliosis PT Matters</h3>
            <p className="home-scoliosis-why-text">
              Scoliosis isn't just about the curve; it's about how that curve affects your breathing, 
              balance, and long-term joint health. Our goal is to empower patients with the physical 
              strength and awareness needed to manage their spinal health confidently.
            </p>
          </div>

          {/* Unique Under-One-Roof Message */}
          <div className="home-scoliosis-unique">
            <div className="home-scoliosis-unique-content">
              <h4>Exclusive "Under-One-Roof" Approach</h4>
              <p>
                We offer a unique, <strong>"under-one-roof"</strong> approach where your physiotherapist and orthotist 
                collaborate directly to ensure your scoliosis treatment is perfectly coordinated.
              </p>
            </div>
          </div>

          <div className="home-scoliosis-buttons">
            <Link to="/spinal-orthotics" className="home-scoliosis-btn home-scoliosis-btn-primary">
              More Information →
            </Link>
          </div>
        </div>

        {/* Right Image */}
        <div className="home-scoliosis-image">
          <img src="/scoliosis_5.jpg" alt="Scoliosis Treatment" />
        </div>

      </div>
    </section>










  {/* Why Choose Section */}
      <section className="physiotherapy-why-choose-section">
        <div className="physiotherapy-why-choose-container">

          <div className="physiotherapy-why-choose-text">
            <h2>Physiotherapy For Rehabilitation Services</h2>

            <p>
              At our center, we believe that movement is medicine. Our physical 
              therapy department is dedicated to helping you regain strength, improve mobility, 
              and manage pain through evidence-based practices. Whether you are recovering from 
              surgery, managing a chronic condition, or rehabilitating a sports injury, our 
              expert therapists provide personalized care to get you back to your daily life.
            </p>

            <div className="physiotherapy-highlight-section">

              <div className="physiotherapy-highlight-box">
                <h3>What We Offer</h3>
                <ul>
                  <li>Post-Surgical Rehabilitation: Specialized recovery plans for joint replacements, ligament repairs, and orthopedic surgeries.</li>
                  <li>Pain Management: Manual therapy and targeted exercises to alleviate chronic back, neck, and joint pain.</li>
                  <li>Neurological Rehabilitation: Supporting patients with stroke recovery, Parkinson's, and other neurological conditions to improve balance and coordination.</li>
                  <li>Geriatric Care: Focused programs to improve mobility, prevent falls, and maintain independence in older adults.</li>
                  <li>Sports Injury Recovery: Helping athletes of all levels return to peak performance safely and quickly.</li>
                </ul>
              </div>

              <div className="physiotherapy-highlight-box">
                <h3>Why Choose Us?</h3>
                <ul>
                  <li>Personalized Treatment Plans: We don't believe in "one-size-fits-all." Every patient receives a comprehensive assessment and a plan tailored to their specific goals.</li>
                  <li>Integrated Care: As a multidisciplinary rehab center, our physical therapists work closely with our prosthetics and orthotics specialists to ensure seamless, holistic care.</li>
                  <li>State-of-the-Art Facilities: We use modern equipment and techniques to ensure your recovery is efficient and effective.</li>
                  <li>Empowerment through Education: We teach you the "why" behind your exercises, giving you the tools to manage your health long after your sessions end.</li>
                </ul>
              </div>

            </div>
          </div>

          <div className="physiotherapy-why-choose-image">
            <img src="/physiotherapy.png" alt="Physiotherapy For Rehabilitation Services" />
          </div>

        </div>
      </section>







<section className="benefits-section">
  <h2 className="section-title">
    Why Choose Our Rehabilitation & Prosthetic Services
  </h2>

  <div className="benefits-grid">

    <div className="benefits-column left">
      {leftBenefits.map(renderBenefit)}
    </div>

    <div className="benefit-image-container">
      <img
        src="/southern rehab care why choose.png"
        alt="Orthopedic Rehabilitation"
        className="benefit-image"
      />
    </div>

    <div className="benefits-column right">
      {rightBenefits.map(renderBenefit)}
    </div>

  </div>
</section>











<div className="monarch-hotel-container">
      <h1 className="monarch-hotel-heading">
      Comprehensive Orthopedic Rehabilitation and Prosthetic & Orthotic Solutions
      </h1>

<p className="monarch-hotel-para">
We provide advanced orthopedic rehabilitation, high-quality prosthetic limbs, and custom orthotic solutions 
designed to improve mobility, comfort, and independence. Our dedicated team delivers personalized care for adults and 
children, ensuring reliable support and long-term well-being.
</p>
      <div 
        className="monarch-carousel-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="monarch-carousel">
          {visibleImages.map((image, i) => (
            <div 
              key={`${image.src}-${i}`}
              className={`carousel-item ${i === 1 ? 'center-item' : ''}`}
              onClick={() => handleImageClick(image)}
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
        <div className="carousel-controls">
          <button className="carousel-prev" onClick={movePrev}>&lt;</button>
          <button className="carousel-next" onClick={moveNext}>&gt;</button>
        </div>
      </div>

      {expandedImage && (
        <div className="image-modal" onClick={closeExpandedImage}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={closeExpandedImage}>&times;</button>
            <img 
              src={expandedImage.src} 
              alt={expandedImage.alt} 
              className="expanded-image"
            />
            <div className="image-caption">{expandedImage.alt}</div>
          </div>
        </div>
      )}
    </div>




{/*customer feedbacks*/}





    </main>
  );
}

export default Body;